export default __webpack_public_path__ + "static/media/ic_chat_black.f2b05afe.svg";